import { parseISO } from "date-fns";
import { z } from "zod";

const StripeConnectionSchema = z.object({
  environment: z.enum(["test", "live"]),
  status: z.enum(["not_connected", "setup_incomplete", "verification_pending", "connected", "action_required", "connection_removed"]),
  account: z.object({
    id: z.string(), businessName: z.string().nullable(), country: z.string(), currency: z.string().nullable(),
  }).nullable(),
  lastSyncedAt: z.date().nullable(),
});
const StripeConnectionDtoSchema = z.object({
  environment: StripeConnectionSchema.shape.environment,
  status: StripeConnectionSchema.shape.status,
  account: z.object({
    id: z.string(), business_name: z.string().nullable(), country: z.string(), currency: z.string().nullable(),
  }).nullable(),
  last_synced_at: z.iso.datetime({ offset: true }).nullable(),
});
export type StripeConnectionDto = z.infer<typeof StripeConnectionDtoSchema>;
export type StripeConnection = z.infer<typeof StripeConnectionSchema>;

export function fromStripeConnectionDtoToStripeConnection(dto: StripeConnectionDto): StripeConnection {
  const parsed = StripeConnectionDtoSchema.parse(dto);
  return {
    environment: parsed.environment, status: parsed.status,
    account: parsed.account ? {
      id: parsed.account.id, businessName: parsed.account.business_name,
      country: parsed.account.country, currency: parsed.account.currency,
    } : null,
    lastSyncedAt: parsed.last_synced_at ? parseISO(parsed.last_synced_at) : null,
  };
}
